export default (ctx, html) => html`
  <div>
    <slot></slot>
  </div>
`;
